"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgMugOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M14.5 8c1.333 0 2 .667 2 2v1c2.667 0 4 1.333 4 3.999v1c0 2.667-1.333 4.001-4 4.001 0 1.333-.666 2-1.999 2H5.5c-1.333 0-2-.667-2-2V10c0-1.333.667-2 2-2h9zm0 2h-9v10h9V10zm2 3v5c1.273 0 1.938-.607 1.996-1.822L18.5 16v-.997c0-1.335-.667-2.003-2-2.003zM7.505 2c.663 0 .995.333.995 1v3c0 .667-.334 1-1 1-.666 0-1-.333-1-1V3c.006-.667.341-1 1.005-1zM11.5 4c.666 0 1 .333 1 1v1c0 .667-.332 1-.996 1-.663 0-.998-.333-1.004-1V5c0-.667.334-1 1-1z' }))); };
exports.default = SvgMugOutline;
//# sourceMappingURL=MugOutline.js.map